import { TOGGLE_SIDEBAR } from "../types/type"

export const toggleSideBar = (data) => {
    return {
        type: TOGGLE_SIDEBAR,
        payload: data
    }
}